import { CompanyDto, VehicleClusterInformationDto } from 'dtos'
import * as yup from 'yup'

export class VehicleCheckInDetailsDto {
  vehicleId?: number = undefined
  vin?: string = undefined
  exporterCompany?: CompanyDto = undefined
  year?: number = undefined
  make?: string = undefined
  model?: string = undefined
  importerStockNumber?: string = undefined

  vehicleCheckInBondNumber?: string = undefined

  vehicleCheckInDateTime?: string = undefined

  vehicleCheckInOdometerReadingMileage?: number = undefined
  vehicleCheckInOdometerReadingUnitOfMeasurement?: string = undefined
  vehicleCheckInOdometerReadingMi?: number = undefined
  vehicleCheckInOdometerReadingKm?: number = undefined

  convertCluster?: boolean = false

  vehicleCheckInClusterConversionInHouseOrThirdParty?: string = undefined
  vehicleCheckInThirdPartyClusterConversionCompany?: CompanyDto = undefined
  vehicleCheckInAdditionalProgramming?: boolean = undefined
  vehicleCheckInAdditionalProgrammingInHouseOrThirdParty?: string = undefined
  vehicleCheckInThirdPartyAdditionalProgrammingCompany?: CompanyDto = undefined

  programCluster?: boolean = false
  vehicleCheckInMFGBuildDateMonth?: number = undefined
  vehicleCheckInMFGBuildDateYear?: number = undefined
  vehicleCheckInParkingSpace?: string = undefined
  vehicleCheckInWeightGVWR?: number = undefined
  vehicleCheckInWeightGVWRUnitOfMeasurement?: string = undefined
  vehicleCheckInWeightGVWRKg?: number = undefined
  vehicleCheckInWeightGVWRLbs?: number = undefined
  vehicleCheckInCurbWeight?: number = undefined
  vehicleCheckInWeightGAWRFR?: number = undefined
  vehicleCheckInWeightGAWRFRUnitOfMeasurement?: string = undefined
  vehicleCheckInWeightGAWRFRKg?: number = undefined
  vehicleCheckInWeightGAWRFRLbs?: number = undefined
  vehicleCheckInWeightGAWRRR?: number = undefined
  vehicleCheckInWeightGAWRRRUnitOfMeasurement?: string = undefined
  vehicleCheckInWeightGAWRRRKg?: number = undefined
  vehicleCheckInWeightGAWRRRLbs?: number = undefined
  vehicleCheckInFrontTires?: string = undefined
  vehicleCheckInFrontRims?: string = undefined
  vehicleCheckInFrontTiresPressure?: number = undefined
  vehicleCheckInFrontTiresPressureUnitOfMeasurement?: string = undefined
  vehicleCheckInFrontTiresPressurekPa?: number = undefined
  vehicleCheckInFrontTiresPressurePSI?: number = undefined
  vehicleCheckInRearTires?: string = undefined
  vehicleCheckInRearRims?: string = undefined
  vehicleCheckInRearTiresPressure?: number = undefined
  vehicleCheckInRearTiresPressureUnitOfMeasurement?: string = undefined
  vehicleCheckInRearTiresPressurekPa?: number = undefined
  vehicleCheckInRearTiresPressurePSI?: number = undefined
  vehicleCheckInNumberOfRearTires?: number = undefined
  vehicleCheckInRearTireConfig?: string = undefined
  importerNotes?: string = undefined

  isCheckedIn?: boolean = undefined

  vehicleClusterInformation?: VehicleClusterInformationDto = undefined
}

export const vehicleCheckInDetailsValidationSchema = yup.object({
  vehicleCheckInOdometer: yup.number().required('Vehicle Check In Odometer is required.'),
  vehicleCheckInOdometerUnitOfMeasurement: yup.string().required('Vehicle Check In Odometer Unit Of Measurement is required.'),
  vehicleCheckInFrontTires: yup.string().required('Front Tires is required.'),
  convertCluster: yup.bool().required('Convert Cluster is required.'),
  vehicleCheckInFrontRims: yup.string().required('Front Rims is required.'),
  vehicleCheckInFrontTiresPressure: yup.number().required('Front Tires Pressure is required.'),
  vehicleCheckInMFGBuildDateMonth: yup.number().required('Manufactured Date Month is required.'),
  vehicleCheckInMFGBuildDateYear: yup.number().required('Manufactured Date Year is required.'),
  vehicleCheckInRearTires: yup.string().required('Rear Tires is required.'),
  vehicleCheckInWeightGVWR: yup.number().required('GVWR is required.'),
  vehicleCheckInRearRims: yup.string().required('Rear Rims is required.'),
  vehicleCheckInWeightGAWRFR: yup.number().required('GAWR FR is required.'),
  vehicleCheckInWeightGAWRFRUnitOfMeasurement: yup.string().required('GAWR FR Unit Of Measurement is required.'),
  vehicleCheckInRearTiresPressure: yup.number().required('Rear Tires Pressure is required.'),
  vehicleCheckInWeightGAWRRR: yup.number().required('GAWR RR is required.'),
  vehicleCheckInWeightGAWRRRUnitOfMeasurement: yup.string().required('GAWR RR Unit Of Measurement is required.'),
  vehicleCheckInNumberOfRearTires: yup.number().required('Number of Rear Tires is required.')
})

export const vehicleCheckInStep1ValidationSchema = yup.object({
  vehicleCheckInOdometerReadingMileage: yup.number().required('Vehicle Check-In Odometer Reading is required.'),
  vehicleCheckInOdometerReadingUnitOfMeasurement: yup.string().required('Odometer Reading Unit Of Measurement is required.'),
  convertCluster: yup.bool().required('Convert Cluster is required.'),
  vehicleCheckInMFGBuildDateMonth: yup.number().required('MFG Build Date (Month) is required.'),
  vehicleCheckInMFGBuildDateYear: yup.number().required('MFG Build Date (Year) is required.'),
  vehicleCheckInParkingSpace: yup
    .string()
    .transform(v => (v === '' || v == null ? undefined : v))
    .max(20, 'Parking Space cannot be more than 20 characters.')
    .optional(),
  vehicleCheckInWeightGVWR: yup.number().required('GVWR is required.'),
  vehicleCheckInWeightGVWRUnitOfMeasurement: yup.string().required('GVWR Unit Of Measurement is required.'),
  vehicleCheckInWeightGAWRFR: yup.number().required('GAWR FR is required.'),
  vehicleCheckInWeightGAWRFRUnitOfMeasurement: yup.string().required('GAWR FR Unit Of Measurement is required.'),
  vehicleCheckInWeightGAWRRR: yup.number().required('GAWR RR is required.'),
  vehicleCheckInWeightGAWRRRUnitOfMeasurement: yup.string().required('GAWR RR Unit Of Measurement is required.'),
  vehicleCheckInFrontTires: yup.string().required('Front Tires is required.'),
  vehicleCheckInFrontRims: yup.string().required('Front Rims is required.'),
  vehicleCheckInFrontTiresPressure: yup.number().required('Front Tires Pressure is required.'),
  vehicleCheckInFrontTiresPressureUnitOfMeasurement: yup.string().required('Front Tires Pressure Unit Of Measurement is required.'),
  vehicleCheckInRearTires: yup.string().required('Rear Tires is required.'),
  vehicleCheckInRearRims: yup.string().required('Rear Rims is required.'),
  vehicleCheckInRearTiresPressure: yup.number().required('Rear Tires Pressure is required.'),
  vehicleCheckInRearTiresPressureUnitOfMeasurement: yup.string().required('Rear Tires Pressure Unit Of Measurement is required.'),
  vehicleCheckInNumberOfRearTires: yup.number().required('Number of Rear Tires is required.'),
  importerNotes: yup.string().max(2_000, 'Importer Notes cannot be more than 2,000 characters.').nullable()
})
